"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownItem = DropdownItem;
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable */
/* TODO: fix ALL linting errors as some may call out code smells */
const prop_types_1 = __importDefault(require("prop-types"));
const classnames_1 = __importDefault(require("classnames"));
const dropdown_item_module_scss_1 = __importDefault(require("./dropdown-item.module.scss"));
function DropdownItem({ className = '', children, text, value, selected, disabled, onSelect = () => { }, ...other }) {
    const classes = (0, classnames_1.default)(dropdown_item_module_scss_1.default['dropdownItem'], { [dropdown_item_module_scss_1.default['dropdownItem--is-selected']]: selected }, { [dropdown_item_module_scss_1.default['dropdownItem--is-disabled']]: disabled }, className);
    const handleSelect = () => onSelect({ value, text: children });
    // TODO: currently handleClick does the same thing
    // but building this out to provide for better accessibility later
    const handleKeyUp = (event) => {
        const isValidKeyPress = event.key === 'Enter';
        if (isValidKeyPress) {
            handleSelect();
        }
    };
    return ((0, jsx_runtime_1.jsx)("li", { value: value, className: classes, onClick: handleSelect, onKeyUp: handleKeyUp, tabIndex: -1, "aria-selected": selected, "aria-disabled": disabled, role: "option", ...other, children: children || text }));
}
DropdownItem.propTypes = {
    children: prop_types_1.default.node,
    className: prop_types_1.default.string,
    disabled: prop_types_1.default.bool,
    onSelect: prop_types_1.default.func,
    selected: prop_types_1.default.bool,
    text: prop_types_1.default.string.isRequired,
    value: prop_types_1.default.oneOfType([
        prop_types_1.default.string,
        prop_types_1.default.number
    ]).isRequired
};
exports.default = DropdownItem;
//# sourceMappingURL=dropdown-item.js.map